import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions/Organization";
import { getThinkerOrganizations } from "../../apiFactory/QueryBuilder";
import { trackPageThroughGA } from "../../services/googleAnalytics";
import { getSecureImage } from "../../services/DashboardDesigner/widgetService";
import WithLoader from "../../components/HOC/WithLoader";
import MessageBox from "../../components/Display/MessageBox";
import { getAccessibleDashboardOrgIds } from "../../apiFactory/DashboardDesigner/SIP-CRUD";
import { getRoles } from "../../apiFactory/DashboardDesigner/P3fy";
import { isEditAccessible } from "../../services/helper";
import { logger } from "../../utility/logger";
import { setHelpDeskPrefill } from "../DashboardDesigner/utils";
import uniqusLogo from "../../assets/uniqus-logo.png"
import { withRouter as customWithRouter } from '../../hoc/withRouter';

class OrganizationListing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			organizations: [],
			loading: true
		};
	}

	componentDidMount() {
		logger("OrganizaionListing mounted", "success");
		const page = window.location.pathname;
		trackPageThroughGA(page, {});
		document.title = "Canvas";
		const that = this;
		const { resetOrganizationAction } = this.props;
		resetOrganizationAction();
		Promise.all([
			getThinkerOrganizations(),
			getAccessibleDashboardOrgIds(),
			getRoles().catch(() => [])
		])
			.then(([response, accessibleOrgIds, adminRoles]) => {
				let organizations = (response.data || []).map(organization => {
					const obj = {};
					obj.orgName = organization.name;
					obj.orgId = organization.organizationId;
					// Store the original logoUrl - we'll handle fallback in render
					obj.orgUrl = organization.logoUrl || null;
					return obj;
				});

				// The organization list is scoped by organization membership, not by
				// dashboard access, so a user who belongs to an org but was never granted
				// a dashboard in it used to land on "You do not have access to view the
				// dashboards". Only surface orgs the user can actually open. Canvas admins
				// keep the full list, and a failed lookup (null) fails open.
				const isAdmin = isEditAccessible(adminRoles || []);
				if (!isAdmin && Array.isArray(accessibleOrgIds)) {
					organizations = organizations.filter(org =>
						accessibleOrgIds.includes(Number(org.orgId))
					);
				}

				that.setState({ organizations });
			})
			.then(() => {
				const { organizations } = this.state;
				if (organizations.length === 1) {
					this.initOrganization(organizations[0].orgId);
				} else {
					this.setState({ loading: false });
				}
			})
			.catch(() => {
				this.setState({ loading: false });
			});
	}

	componentDidUpdate() {
		const { userDetails } = this.props;
		setHelpDeskPrefill(userDetails, { orgId: "", dashboardName: "" }, window.location.href);
	}

	initOrganization = organizationId => {
		const { history } = this.props;
		history.push(`/${organizationId}`);
	};

	render() {
		logger("OrganizaionListing Rendered", "success");
		const { organizations, loading } = this.state;
		const sortedOrganizations = organizations
			? organizations.sort((a, b) =>
					// eslint-disable-next-line no-nested-ternary
					a.orgName.toLowerCase() > b.orgName.toLowerCase()
						? 1
						: b.orgName.toLowerCase() > a.orgName.toLowerCase()
						? -1
						: 0
			  )
			: [];

		if (!loading && sortedOrganizations.length === 0) {
			return (
				<MessageBox
					type="noAccess"
					text="You do not have access to view the dashboards. Please contact your Uniqus administrator for access."
				/>
			);
		}

		return (
			<WithLoader loading={loading}>
				<>
					<div className="jumbotron bg-white d-flex">
						<div className="container">
							<div className="mt-2 mb-1 tx-black tx-size-20 pl-0">Welcome to Canvas</div>
							<div className="mt-2 mb-1 tx-light-black tx-size-14 pl-0">
								Select an organization to continue.
							</div>
						</div>
					</div>
					<div className="row organization-card-container">
						{sortedOrganizations.map((organization, index) => {
							const ind = index;
							return (
								<div
									key={ind}
									className="col-xs-1 col-md-4 col-lg-3"
									onClick={() => {
										this.initOrganization(organization.orgId);
									}}
								>
									<div className="organization-card m-2">
										<div className="organization-card-icon">
											{organization.orgUrl ? (
												<img
													style={{ maxHeight: 50, maxWidth: "100%" }}
													src={getSecureImage(organization.orgUrl)}
													alt={`${organization.orgName} logo`}
													onError={(e) => {
														e.target.onerror = null;
														e.target.src = uniqusLogo;
													}}
												/>
											) : (
												<img
													style={{ maxHeight: 50, maxWidth: "100%" }}
													src={uniqusLogo}
													alt={`${organization.orgName} logo`}
												/>
											)}
										</div>
										<div className="mt-3">
											<p>{organization.orgName}</p>
										</div>
									</div>	
								</div>
							);
						})}
					</div>
				</>
			</WithLoader>
		);
	}
}

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

const mapStateToProps = state => {
	return {
		userDetails: state.userInfo
	};
};

export default customWithRouter(connect(mapStateToProps, mapDispatchToProps)(OrganizationListing));
